import React, { FC } from 'react';
import { Row } from '@tanstack/react-table';

import TicketWithConnection from 'types/TicketWithConnection';
import LinkWithIcon from 'components/LinkWithIcon/LinkWithIcon';
import { useLinkedCriterionUrl } from 'hooks/useLinkedCriterionUrl';

export interface LinkedCriterionCellProps {
  row: Row<TicketWithConnection>;
}

const LinkedCriterionCell: FC<LinkedCriterionCellProps> = ({ row }) => {
  const value = row.original.connection;
  const url = useLinkedCriterionUrl(value);

  if (!value) {
    return <span>-</span>;
  }

  return (
    <LinkWithIcon to={url} color="#4A4A4A">
      {value.element_name}
    </LinkWithIcon>
  );
};

export default LinkedCriterionCell;
